export default {
  cbam_news: "CBAM News",
  view_all_news: "View All News",
  search_news: "Search news...",
  no_news: "No news available",
  fetch_news_failed: "Failed to fetch news",
};
